import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';
import DateTime from 'react-datetime';
import * as moment from 'moment';

class TaskForm extends React.Component {
  constructor() {
    super();

    this.state = {
      primary: {},
    };
  }

  componentDidMount() {
    //const initialValues = this.props;
  }

  renderField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <input
            {...input}
            className="form-control"
            placeholder={label}
            type={type}
            disabled={disabled}
            maxLength={maxLength}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  renderLabelField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          {type}
          <input
            {...input}
            className="form-control"
            placeholder={label}
            type={type}
            disabled={disabled}
            maxLength={maxLength}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    maxLength,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <DateTime
            // dateFormat="YYYY-MM-DD"
            timeFormat={true}
            viewDate={input.value}
            {...input}
            renderInput={(props, openCalendar, closeCalendar) => {
              const value =
                props.value && moment(props.value)
                  ? moment(props.value).format('MM/DD/YYYY')
                  : moment().format('MM/DD/YYYY');
              return (
                <div className="input-group">
                  <input {...props} type="hidden" />
                  <input
                    className="form-control"
                    type="text"
                    value={value}
                    readOnly
                    onFocus={openCalendar}
                  />
                  <span className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar" />
                  </span>
                </div>
              );
            }}
            renderDay={(props, currentDate, selectedDate) => {
              return <td {...props}>{currentDate.date()}</td>;
            }}
            onChange={param => {
              if (param) {
                // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
                input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
                // input.onChange(param)
              }
            }}
            disabled={disabled}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <AsyncSelect
            value={input.value}
            cacheOptions
            defaultOptions
            isMulti
            loadOptions={this.searchClients}
            getOptionValue={(option) => option.code}
            getOptionLabel={(option) => option.name}
            placeholder="Type Client Name..."
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99999,
                color: '#108ee9',
              }),
            }}
            onChange={this.onClientChange}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  searchClients = (search) => {
    return this.props.searchClients(search);
  }

  onClientChange = (val) => {
    this.props.change('associatedToClient', val);
  }

  renderUsersSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <AsyncSelect
            value={input.value}
            cacheOptions
            defaultOptions
            isMulti
            loadOptions={this.searchUsers}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            placeholder="Type User Name..."
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99999,
                color: '#108ee9',
              }),
            }}
            onChange={this.onUserChange}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  searchUsers = (search) => {
    return this.props.searchUsers(search, 'isActive');
  }

  onUserChange = (val) => {
    this.props.change('associatedToUser', val);
  }

  renderAssignmentSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <AsyncSelect
            value={input.value}
            cacheOptions
            defaultOptions
            //isMulti
            loadOptions={this.searchUsers}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            placeholder="Type User Name..."
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99999,
                color: '#108ee9',
              }),
            }}
            onChange={this.onAssignmentChange}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  onAssignmentChange = (val) => {
    this.props.change('assignedTo', val);
  }

  renderPatientsSelect = ({
    meta: { touched, error, warning },
    label,
    input,
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <AsyncSelect
            value={input.value}
            cacheOptions
            defaultOptions
            isMulti
            loadOptions={this.searchPatients}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.name}
            placeholder="Type Patient Name..."
            styles={{
              control: styles => ({
                ...styles,
                borderColor: touched && error ? 'red' : '#cccccc',
              }),
              menu: styles => ({
                ...styles,
                zIndex: 99999,
                color: '#108ee9',
              }),
            }}
            onChange={this.onPatientChange}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  searchPatients = (search) => {
    return this.props.searchPatients(search);
  }

  onPatientChange = (val) => {
    this.props.change('associatedToPatient', val);
  }

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      initialValues
    } = this.props;

    const showEscalation = initialValues.associatedToEscalation === null;
    const showEvent = initialValues.associatedToEvent === null;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Task Information</legend>
          <Field
            className="form-control"
            name="task"
            component={this.renderField}
            type="text"
            placeholder="Task"
            label="Task"
          />
          <Field
            className="form-control"
            name="dueDate"
            component={this.renderDateField}
            type="text"
            placeholder="DueDate"
            label="Due Date"
          />
          <Field
            className="form-control"
            name="associatedToClient"
            component={this.renderClientsSelect}
            label="Associate To Client"
          />
          <Field
            className="form-control"
            name="associatedToUser"
            component={this.renderUsersSelect}
            label="Associate To User"
          />
          <Field
            className="form-control"
            name="associatedToPatient"
            component={this.renderPatientsSelect}
            label="Associate To Patient"
          />
          <Field
            className="form-control"
            name="assignedTo"
            component={this.renderAssignmentSelect}
            label="Assigned To"
          />
          {!showEscalation &&
            <Field
            className="form-control"
            name="escalationIssueName"
            component={this.renderLabelField}
            label="Related To"
            type="Escalation"
            disabled={true}
            />
          }
          {!showEvent &&
            <Field
              className="form-control"
              name="eventPlan"
              component={this.renderLabelField}
              label="Related To"
              type="Event"
              disabled={true}
            />
          }
        </fieldset>
        <fieldset>
          <div className="form-group">
            <label className="col-md-2 control-label">Completed</label>
            <div className="col-md-10">
              <div className="checkbox">
                <label>
                  <Field
                    name="isCompleted"
                    component="input"
                    type="checkbox"
                  />
                </label>
              </div>
            </div>
          </div>
        </fieldset>
        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.task) {
    errors.task = 'Required';
  }
  if (!values.dueDate) {
    errors.dueDate = 'Required';
  }
  if (!values.assignedTo) {
    errors.assignedTo = 'Required';
  }

  return errors;
};

TaskForm = connect(state => ({
  formValues: getFormValues('task')(state),
  initialValues: state.taskmanager.task,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'task' })(TaskForm));
export default TaskForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/TaskForm.js